import React, { Fragment, useEffect } from "react";

import {
  BarChart,
  Bar,
  Cell,
  Tooltip,
  ResponsiveContainer,
  YAxis,
  XAxis,
} from "recharts";

import {
  CustomizedYAxisTick,
  StandardTooltip,
  selectFormat,
  Error,
  MAIN_COLORS,
} from "components/Utils/Utils.js";

const DonationsByLongetivity = (props) => {
  const { data } = props;

  useEffect(() => {
    props.childRef({ getExportData });
  });

  const getExportData = () => ({
    data: preparedData,
    opts: {
      type: "chart",
      date: {
        no_date: true,
        title: "Series",
        name: "name",
      },
      exclude: ["name"],
    },
  });

  if (data.hasData === false) {
    return <Error minHeight={360} />;
  }

  const preparedData = [];
  Object.keys(data.data).forEach((d) =>
    preparedData.push({ name: d, value: data.data[d] })
  );

  return (
    <ResponsiveContainer height={485}>
      <BarChart
        data={preparedData}
        margin={{ top: 10, right: 0, left: 0, bottom: 10 }}
      >
        <Tooltip
          cursor={{ fill: "#eee", opacity: 0.5 }}
          content={
            <StandardTooltip
              render={({ data }) => {
                const payload = data(props);
                if (payload !== null) {
                  return (
                    <div className="standard-tooltip">
                      {Object.keys(payload).map((key) => (
                        <Fragment key={key}>
                          <header className="standard-tooltip__header">
                            <span className="standard-tooltip__key-header">
                              {props.title}
                            </span>
                            {/* <span className="standard-tooltip__value-heade">
                              {payload[key].payload.name}
                            </span> */}
                          </header>
                          <main className="standard-tooltip__main">
                            <div className="standard-tooltip__item">
                              <span className="standard-tooltip__key">
                                <span
                                  className="standard-tooltip__icon"
                                  style={{ background: payload[key].color }}
                                />
                                {payload[key].payload.name}
                              </span>
                              <span className="standard-tooltip__value">
                                {selectFormat("number", payload[key].value)}
                              </span>
                            </div>
                          </main>
                        </Fragment>
                      ))}
                    </div>
                  );
                }
              }}
            />
          }
        />
        <XAxis
          type="category"
          axisLine={false}
          tickLine={false}
          mirror={false}
          dataKey="name"
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          mirror={true}
          tick={<CustomizedYAxisTick />}
        />

        <Bar dataKey="value" fill="#eb5b57">
          {preparedData.map((d, index) => (
            <Cell key={`cell-${index}`} fill={MAIN_COLORS[index % 20]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default DonationsByLongetivity;
